function Disclaimer() {
  return (
    <div className="md:mx-auto md:max-w-3xl">
      <div className="text-center font-serif text-black text-opacity-50 bg-white border-black border border-opacity-10 px-2.5 py-5 text-sm">
        Paid for by Shield PAC,{' '}
        <a
          href="https://shieldpac.org"
          className="text-cerulean text-opacity-80"
        >
          www.shieldpac.org
        </a>
        , and not authorized by any candidate or candidate’s committee.
      </div>
    </div>
  );
}

export default Disclaimer;
